// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedGlaucoma_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M1.42982 8.12688C1.59023 7.85376 1.73106 7.61398 1.82951 7.41667C3.65902 4.20833 7.00244 1 11.4543 1C16.4344 1 20.6046 4.63221 21.6831 9.50587C22.9783 9.59966 23.9999 10.6802 23.9999 11.9993C23.9999 13.3183 22.9784 14.3987 21.6834 14.4926C20.6055 19.367 16.4349 23 11.4543 23C7.00244 23 3.65902 20.7083 1.82951 16.5833C1.72599 16.3499 1.55658 16.0571 1.36154 15.72C0.790583 14.7331 0 13.3665 0 12C0 10.5613 0.845003 9.12259 1.42982 8.12688ZM19.9541 12C19.9541 17.0593 16.0619 21 11.4543 21C7.83954 21 5.18574 19.2176 3.65776 15.7725C3.51003 15.4394 3.29495 15.0678 3.1273 14.7782L3.10332 14.7368C2.90874 14.4004 2.72049 14.075 2.54622 13.7312C2.18172 13.0121 2 12.4381 2 12C2 11.5474 2.18001 10.9647 2.53284 10.2575C2.7013 9.9199 2.88713 9.59576 3.07645 9.27255L3.14867 9.14958C3.29355 8.90325 3.46152 8.61767 3.5905 8.36614C5.25466 5.47058 8.04891 3 11.4543 3C16.0619 3 19.9541 6.9407 19.9541 12Z" class="svg-bg"/>
  <path d="M11.0001 11H15.0001V9L19.0001 12 15.0001 15 15.0001 13H11.0001V11ZM6.64254 8.95573 9.46802 6.12435 8.05528 4.70867 12.9999 4.00082 12.2935 8.95573 10.8808 7.54004 8.05528 10.3714 6.64254 8.95573ZM6.64268 15.054 9.46816 17.8854 8.05542 19.3011 13 20.0089 12.2936 15.054 10.8809 16.4697 8.05542 13.6383 6.64268 15.054Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedGlaucoma is a generated icon component.
 */
let IconMedGlaucoma = IconMedGlaucoma_1 = class IconMedGlaucoma extends IconBaseElement {
    render() {
        return html `${IconMedGlaucoma_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedGlaucoma.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedGlaucoma = IconMedGlaucoma_1 = __decorate([
    customElement('zui-icon-med-glaucoma')
], IconMedGlaucoma);
export { IconMedGlaucoma };
